export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтверждение операции"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите код подтверждения"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отмена"])}
}